import { FieldConfig, FieldRules, FieldRulesConfig } from '@/types/form'

export interface CouponFormState {
  coupon_code: string
  description: string
  discount_type: 'percentage' | 'fixed_amount'
  discount: number
  min_order_amount: number
  max_discount_amount: number
  usage_period_days: number
  usage_limit: number
  expiry_date: string
  status: 'active' | 'inactive'
}

export const couponFields: (keyof CouponFormState)[] = [
  'coupon_code',
  'description',
  'discount_type',
  'discount',
  'min_order_amount',
  'max_discount_amount',
  'usage_period_days',
  'usage_limit',
  'expiry_date',
  'status',
]

interface CouponFieldsConfig extends FieldConfig<{
  coupon_code: FieldRules<CouponFormState['coupon_code']>
  description: FieldRules<CouponFormState['description']>
  discount_type: FieldRules<CouponFormState['discount_type']>
  discount: FieldRules<CouponFormState['discount']>
  min_order_amount: FieldRules<CouponFormState['min_order_amount']>
  max_discount_amount: FieldRules<CouponFormState['max_discount_amount']>
  usage_period_days: FieldRules<CouponFormState['usage_period_days']>
  usage_limit: FieldRules<CouponFormState['usage_limit']>
  expiry_date: FieldRules<CouponFormState['expiry_date']>
  status: FieldRules<CouponFormState['status']>
}> {}

interface CouponFieldsConfigProps extends FieldRulesConfig<CouponFormState> {}

export function couponFieldsConfig(props: CouponFieldsConfigProps): CouponFieldsConfig {
  const { formValues } = props

  return {
    fields: {
      coupon_code: {
        rules: {
          required: 'Coupon code is required',
          validate: (value) => {
            if (!value) return true
            if (value.length < 3) return 'Coupon code must be at least 3 characters'
            if (!/^[A-Z0-9_-]+$/.test(value)) {
              return 'Coupon code can only contain uppercase letters, numbers, hyphens, and underscores'
            }
            return true
          },
        },
        maxLength: 50,
      },
      description: {
        rules: {
          required: 'Description is required',
        },
      },
      discount_type: {
        rules: {
          required: 'Discount type is required',
        },
      },
      discount: {
        rules: {
          required: 'Discount value is required',
        },
        min: 0,
        max: formValues.discount_type === 'percentage' ? 100 : undefined,
      },
      min_order_amount: {
        min: 0,
      },
      max_discount_amount: {
        rules: {
          validate: (value) => {
            if (value && formValues.min_order_amount && value > formValues.min_order_amount) {
              return 'Maximum discount cannot exceed minimum order amount'
            }
            return true
          },
        },
        min: 0,
      },
      usage_period_days: {
        min: 1,
      },
      usage_limit: {
        min: 1,
      },
      expiry_date: {
        rules: {
          required: 'Expiry date is required',
        },
      },
      status: {
        rules: {
          required: 'Status is required',
        },
      },
    },
  }
}
